export const COMPETENCIAS_ENEM_DESCRICAO = {
  "Competência1": {
    "titulo": "Interpretação pedagógica da escala de proficiência",
    "subTitulo": "COMPETÊNCIA I: Demonstrar domínio da modalidade escrita formal da Língua Portuguesa.",
    "intervalos": [
      {
        "pontuacao": "0",
        "descricao": "Demonstra desconhecimento da modalidade escrita formal da Língua Portuguesa."
      },
      {
        "pontuacao": "1-40",
        "descricao": "Demonstra domínio precário da modalidade escrita formal da Língua Portuguesa, de forma sistemática, com diversificados e frequentes desvios gramaticais, de escolha de registro e de convenções da escrita."
      },
      {
        "pontuacao": "41-80",
        "descricao": "Demonstra domínio insuficiente da modalidade escrita formal da Língua Portuguesa, com muitos desvios gramaticais, de escolha de registro e de convenções da escrita."
      },
      {
        "pontuacao": "81-120",
        "descricao": "Demonstra domínio mediano da modalidade escrita formal da Língua Portuguesa e de escolha de registro, com alguns desvios gramaticais e de convenções da escrita."
      },
      {
        "pontuacao": "121-160",
        "descricao": "Demonstra bom domínio da modalidade escrita formal da Língua Portuguesa e de escolha de registro, com poucos desvios gramaticais e de convenções da escrita."
      },
      {
        "pontuacao": "161-200",
        "descricao": "Demonstra excelente domínio da modalidade escrita formal da Língua Portuguesa e de escolha de registro. Desvios gramaticais ou de convenções da escrita serão aceitos somente como excepcionalidade e quando não caracterizarem reincidência."
      }
    ]
  },
  "Competência2": {
    "titulo": "Interpretação pedagógica da escala de proficiência",
    "subTitulo": "COMPETÊNCIA II: Compreender a proposta de redação e aplicar conceitos das várias áreas do conhecimento para desenvolver o tema, dentro dos limites estruturais do texto dissertativo-argumentativo em prosa.",
    "intervalos": [
      {
        "pontuacao": "0-40",
        "descricao": "Apresenta o assunto, tangenciando o tema, ou demonstra domínio precário do texto dissertativo-argumentativo, com traços constantes de outros tipos textuais."
      },
      {
        "pontuacao": "41-80",
        "descricao": "Desenvolve o tema recorrendo à cópia de trechos dos textos motivadores ou apresenta domínio insuficiente do texto dissertativo-argumentativo, não atendendo à estrutura com proposição, argumentação e conclusão."
      },
      {
        "pontuacao": "81-120",
        "descricao": "Desenvolve o tema por meio de argumentação previsível e apresenta domínio mediano do texto dissertativo-argumentativo, com proposição, argumentação e conclusão."
      },
      {
        "pontuacao": "121-160",
        "descricao": "Desenvolve o tema por meio de argumentação consistente e apresenta bom domínio do texto dissertativo-argumentativo, com proposição, argumentação e conclusão."
      },
      {
        "pontuacao": "161-200",
        "descricao": "Desenvolve o tema por meio de argumentação consistente, a partir de um repertório sociocultural produtivo, e apresenta excelente domínio do texto dissertativo-argumentativo."
      }
    ]
  },
  "Competência3": {
    "titulo": "Interpretação pedagógica da escala de proficiência",
    "subTitulo": "COMPETÊNCIA III: Selecionar, relacionar, organizar e interpretar informações, fatos, opiniões e argumentos em defesa de um ponto de vista.",
    "intervalos": [
      {
        "pontuacao": "0",
        "descricao": "Apresenta informações, fatos e opiniões não relacionados ao tema e sem defesa de um ponto de vista."
      },
      {
        "pontuacao": "1-40",
        "descricao": "Apresenta informações, fatos e opiniões pouco relacionados ao tema ou incoerentes e sem defesa de um ponto de vista."
      },
      {
        "pontuacao": "41-80",
        "descricao": "Apresenta informações, fatos e opiniões relacionados ao tema, mas desorganizados ou contraditórios e limitados aos argumentos dos textos motivadores, em defesa de um ponto de vista."
      },
      {
        "pontuacao": "81-120",
        "descricao": "Apresenta informações, fatos e opiniões relacionados ao tema, limitados aos argumentos dos textos motivadores e pouco organizados, em defesa de um ponto de vista."
      },
      {
        "pontuacao": "121-160",
        "descricao": "Apresenta informações, fatos e opiniões relacionados ao tema, de forma orga-nizada, com indícios de autoria, em defesa de um ponto de vista."
      },
      {
        "pontuacao": "161-200",
        "descricao": "Apresenta informações, fatos e opiniões relacionados ao tema proposto, de forma consistente e organizada, configurando autoria, em defesa de um ponto de vista."
      }
    ]
  },
  "Competência4": {
    "titulo": "Interpretação pedagógica da escala de proficiência",
    "subTitulo": "COMPETÊNCIA IV: Demonstrar conhecimento dos mecanismos linguísticos necessários para a construção da argumentação.",
    "intervalos": [
      {
        "pontuacao": "0",
        "descricao": "Não articula as informações."
      },
      {
        "pontuacao": "1-40",
        "descricao": "Articula as partes do texto de forma precária."
      },
      {
        "pontuacao": "41-80",
        "descricao": "Articula as partes do texto de forma insuficiente, com muitas inadequações, e apresenta repertório limitado de recursos coesivos."
      },
      {
        "pontuacao": "81-120",
        "descricao": "Articula as partes do texto de forma mediana, com inadequações, e apresenta repertório pouco diversificado de recursos coesivos."
      },
      {
        "pontuacao": "121-160",
        "descricao": "Articula as partes do texto, com poucas inadequações, e apresenta repertório diversificado de recursos coesivos."
      },
      {
        "pontuacao": "161-200",
        "descricao": "Articula bem as partes do texto e apresenta repertório diversificado de recursos coesivos."
      }
    ]
  },
  "Competência5": {
    "titulo": "Interpretação pedagógica da escala de proficiência",
    "subTitulo": "COMPETÊNCIA V: Elaborar proposta de intervenção para o problema abordado, respeitando os direitos humanos",
    "intervalos": [
      {
        "pontuacao": "0",
        "descricao": "Não apresenta proposta de intervenção ou apresenta proposta não relacionada ao tema ou ao assunto."
      },
      {
        "pontuacao": "1-40",
        "descricao": "Apresenta proposta de intervenção vaga, precária ou relacionada apenas ao assunto."
      },
      {
        "pontuacao": "41-80",
        "descricao": "Elabora, de forma insuficiente, proposta de intervenção relacionada ao tema, ou não articulada com a discussão desenvolvida no texto."
      },
      {
        "pontuacao": "81-120",
        "descricao": "Elabora, de forma mediana, proposta de intervenção relacionada ao tema e articulada à discussão desenvolvida no texto."
      },
      {
        "pontuacao": "121-160",
        "descricao": "Elabora bem proposta de intervenção relacionada ao tema e articulada à discussão desenvolvida no texto."
      },
      {
        "pontuacao": "161-200",
        "descricao": "Elabora muito bem proposta de intervenção, detalhada, relacionada ao tema e articulada à discussão desenvolvida no texto."
      }
    ]
  }
}